import { DateFormatter } from '@/support/DateFormatter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import OverwriteDateDialog from '@/components/OverwriteDateDialog/OverwriteDateDialog.vue';
import DatePlanningInput from '@/components/DatePlanningInput/DatePlanningInput.vue';
import { OverwriteDateEvent } from '../OverwriteDateDialog/OverwriteDateDialog';

@Component<DatePlanningBlock>({
  components: {
    DatePlanningInput,
    OverwriteDateDialog,
  },
})
export default class DatePlanningBlock extends Vue {
  // #region @Props

  @Prop({ default: '' })
  protected title!: string;

  @Prop({ default: true })
  protected canEdit!: boolean;

  @Prop({ default: null })
  protected originalDate!: string | null;

  @Prop({ default: 'Originele datum' })
  protected originalDateLabel!: string;

  @Prop({ default: null })
  protected currentDate!: string | null;

  @Prop({ default: '' })
  protected name!: string

  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties

  protected isEditingDate = false;

  protected date: DateFormatter = new DateFormatter();

  // #endregion

  // #region Lifecycle Hooks / Init

  // #endregion

  // #region Class methods

  protected onUpdateDate(field: string, date: string): void {
    this.$emit('updateDate', { field, date });
  }

  protected onOverwriteDate(field: string, event: OverwriteDateEvent): void {
    this.$emit('overwriteDate', { field, event });
  }

  // #endregion

  // #region Async methods

  // #endregion

  // #region Getters & Setters

  protected get originalDateIsScheduled(): boolean {
    return !! this.originalDate;
  }

  protected get currentDateIsScheduled(): boolean {
    return !! this.currentDate;
  }

  // #endregion

  // #region @Watchers

  // #endregion
}
